module.exports = __webpack_public_path__ + "img/discover_icon.6b355f90.png";